(() => {
  const initSizeGuides = () => {
    document.querySelectorAll('[data-rn-size-guide]').forEach((dialog) => {
      if (dialog.dataset.rnReady === 'true') return;
      dialog.dataset.rnReady = 'true';

      const title = (dialog.dataset.menuTitle || 'Size Guide').trim().toLowerCase();
      const iframe = dialog.querySelector('[data-rn-size-guide-video]');
      const close = dialog.querySelector('[data-rn-size-guide-close]');

      const setVideo = () => {
        if (!iframe || iframe.src || !dialog.dataset.videoId) return;
        iframe.src = dialog.dataset.videoType === 'vimeo'
          ? `https://player.vimeo.com/video/${dialog.dataset.videoId}`
          : `https://www.youtube-nocookie.com/embed/${dialog.dataset.videoId}?rel=0`;
      };

      document.querySelectorAll('.rn-menu-title').forEach((label) => {
        if (label.textContent.trim().toLowerCase() !== title) return;
        const trigger = label.closest('a, summary');
        if (!trigger) return;

        trigger.classList.add('rn-size-guide-trigger');
        trigger.removeAttribute('aria-current');
        trigger.querySelector('.header__active-menu-item')?.classList.remove('header__active-menu-item');
        trigger.classList.remove('menu-drawer__menu-item--active');
        trigger.setAttribute('aria-haspopup', 'dialog');

        if (trigger.dataset.rnSizeGuideBound === 'true') return;
        trigger.dataset.rnSizeGuideBound = 'true';
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          setVideo();
          dialog.showModal();
        });
      });

      close?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        if (iframe) iframe.src = '';
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initSizeGuides);
  document.addEventListener('shopify:section:load', initSizeGuides);
  document.addEventListener('shopify:block:select', initSizeGuides);
})();
